import { render, staticRenderFns } from "./EtagDialog.vue?vue&type=template&id=065c4315"
import script from "./EtagDialog.vue?vue&type=script&lang=js"
export * from "./EtagDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports